<template>
  <div class="mr-3">
    <button
      type="button"
      :class="[
        'btn btnclass smallerfontsize',
        value.length > 0 ? 'selected' : ''
      ]"
      @click="fieldData.showSpotTypesModal = true"
    >
      Film type
    </button>
    <b-modal
      :no-close-on-backdrop="true"
      @shown="popupIsShown"
      @hide="popupIsHidden"
      @ok="saveFilmtype"
      v-model="fieldData.showSpotTypesModal"
      size="sm"
      body-class="filmtypemodal"
      title="Film types"
    >
      <b-form-group>
        <b-form-checkbox
          v-model="allIsSelected"
          @change="selectAll"
          class="columncheckbox centerlabelandformgroup"
        >
          {{ allIsSelected ? "Deselect all" : "Choose all" }}
        </b-form-checkbox>
        <b-form-checkbox-group
          v-model="chosenFilmTypes"
          :options="fieldData.config.options"
          stacked
          class="centerlabelandformgroup"
        ></b-form-checkbox-group>
      </b-form-group>
      <template #modal-footer="{ cancel, ok }">
        <b-button size="sm" variant="outline-secondary" @click="cancel()">
          Cancel
        </b-button>
        <b-button size="sm" variant="primary" @click="ok()">
          Save
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import computedVal from "@/mixins/computedVal";
import props from "@/mixins/inputProps";
export default {
  name: "FilmTypeBubble",
  mixins: [computedVal, props],
  data() {
    return {
      selected: [], // Must be an array reference!
      allIsSelected: false,
      chosenFilmTypes: []
    };
  },
  methods: {
    onKeyUp(event) {
      if (event.key === "Enter" && this.fieldData.showSpotTypesModal) {
        this.saveFilmtype();
        this.fieldData.showSpotTypesModal = false;
      }
    },
    popupIsShown() {
      if (this.$store.getters[this.getter].spot_types) {
        this.chosenFilmTypes = this.$store.getters[this.getter].spot_types;
      } else this.chosenFilmTypes = [];
      document.addEventListener("keyup", this.onKeyUp);
      if (this.chosenFilmTypes.length === 3) this.allIsSelected = true;
      else if (this.chosenFilmTypes.length === 0) this.allIsSelected = false;
    },
    popupIsHidden() {
      document.removeEventListener("keyup", this.onKeyUp);
    },
    selectAll(checked) {
      if (checked) {
        this.chosenFilmTypes = [
          ...this.fieldData.config.options.map(opt => opt.value)
        ];
      } else {
        this.chosenFilmTypes = [];
      }
    },
    saveFilmtype() {
      const updatedQuery = {
        ...this.$store.getters[this.getter],
        spot_types: this.chosenFilmTypes
      };
      this.$store.commit(this.setter, updatedQuery);
    }
  }
};
</script>
<style scoped>
>>> .columncheckbox, >>> .centerlabelandformgroup div {
  display: flex;
}
.filmtypemodal {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.centerlabelandformgroup {
  width: 8rem;
  margin-left: 4rem;
}
</style>
